// Workaround: x-tabs loses its click handler when reparented (e.g. into a modal
// appended to document.body), since disconnectedCallback tears it down and
// connectedCallback never rebuilds it. Restores switching via `selectedIndex`.
document.querySelectorAll('x-tabs.mon-size-guide-tabs').forEach((tabs) => {
  tabs.addEventListener('click', (event) => {
    const button = event.target.closest?.('button[role="tab"]');
    if (!button || !tabs.shadowRoot) return;

    const buttons = Array.from(tabs.shadowRoot.querySelector('slot[name="title"]')?.assignedElements() ?? []);
    const index = buttons.indexOf(button);

    if (index !== -1) tabs.selectedIndex = index;
  });
});
